import { render, staticRenderFns } from "./LandingNews.vue?vue&type=template&id=feafbffc&"
import script from "./LandingNews.vue?vue&type=script&lang=js&"
export * from "./LandingNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports